/**
 * Copyright (c) OpenSpug Organization. https://github.com/openspug/spug
 * Copyright (c) <spug.dev@gmail.com>
 * Released under the MIT License.
 */
export default [{
  key: 'home',
  label: '工作台',
  pages: [{
    key: 'home',
    label: '工作台',
    perms: [
      {key: 'view', label: '查看工作台'}
    ]
  }]
}, {
  key: 'student',
  label: '学员管理',
  pages: [{
    key: 'info',
    label: '学员信息',
    perms: [
      {key: 'view', label: '查看信息'},
      {key: 'detail', label: '查看详情'},
      {key: 'add', label: '添加信息'},
      {key: 'edit', label: '编辑信息'},
      {key: 'del', label: '删除信息'},
      {key: 'export', label: '导出信息'},
    ]
  }, {
    key: 'coin',
    label: '学员积分',
    perms: [
      {key: 'view', label: '查看积分'},
      {key: 'history', label: '积分明细'},
      {key: 'add', label: '充值积分'},
    ]
  },{
    key: 'work',
    label: '学员工作',
    perms: [
      {key: 'view', label: '查看工作'},
      {key: 'add', label: '添加工作'},
      {key: 'edit', label: '编辑工作'},
      {key: 'del', label: '删除工作'},
    ]
  },{
    key: 'class',
    label: '班级管理',
    perms: [
      {key: 'view', label: '查看班级'},
      {key: 'add', label: '添加班级'},
      {key: 'edit', label: '编辑班级'},
      {key: 'del', label: '删除班级'},
    ]
  }]
}, {
  key: 'homework',
  label: '作业管理',
  pages: [
  //   {
  //   key: 'plan',
  //   label: '作业安排',
  //   perms: [
  //     {key: 'view', label: '查看安排'},
  //     {key: 'add', label: '添加'},
  //     {key: 'edit', label: '编辑'},
  //     {key: 'del', label: '删除'},
  //   ]
  // }, 
  {
    key: 'record',
    label: '提交记录',
    perms: [
      {key: 'view', label: '查看作业'},
      {key: 'add', label: '新建作业'},
      {key: 'edit', label: '编辑作业'},
      {key: 'del', label: '删除作业'},
    ]
  }]
}, 
// {
//   key: 'feedback',
//   label: '回访管理',
//   pages: [{
//     key: 'feedback',
//     label: '回访管理',
//     perms: [
//       {key: 'view', label: '查看回访'},
//       {key: 'add', label: '新建回访'},
//       {key: 'edit', label: '编辑回访'},
//       {key: 'del', label: '删除回访'},
//     ]
//   }]
// }, 
{
  key: 'grade',
  label: '评分管理',
  pages: [{
    key: 'grade',
    label: '评分管理',
    perms: [
      {key: 'view', label: '查看评分'},
      {key: 'add', label: '新建评分'},
      {key: 'edit', label: '编辑评分'},
      {key: 'del', label: '删除评分'},
    ]
  }]
}]
